import { createContext } from "react"

import { Popover } from "@molecules/index"

import { DialogContextValues, DialogProps } from "./Dialog.types"
import DialogBody from "./DialogBody/DialogBody"
import DialogContent from "./DialogContent/DialogContent"
import DialogFooter from "./DialogFooter/DialogFooter"
import DialogHeader from "./DialogHeader/DialogHeader"

export const DialogContext = createContext<DialogContextValues>({
    variant: "default",
})
DialogContext.displayName = "Dialog"

function Dialog(props: DialogProps) {
    const { children, isOpen, onOpenChange, mode = "dialog", variant = "default" } = props

    return (
        <Popover.Root
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            isAnchored={false}
            isDismissable={mode === "dialog"}
            hasDragIndicator={mode === "dialog" && variant !== "focused"}
        >
            <DialogContext.Provider value={{ variant }}>{children}</DialogContext.Provider>
        </Popover.Root>
    )
}

const Root = Dialog
const Content = DialogContent
const Body = DialogBody
const Header = DialogHeader
const Footer = DialogFooter

function Trigger(props: React.ComponentProps<typeof Popover.Trigger>) {
    return <Popover.Trigger {...props} />
}

function Close(props: React.ComponentProps<typeof Popover.Close>) {
    return <Popover.Close {...props} />
}

export default { Root, Content, Body, Header, Footer, Trigger, Close }
